import { loadable } from '../../../utils';

export const Notify = loadable(() => import('./Notify'), {});
export const Product = loadable(() => import('./Product'), {});
